<template>
  <div class="index_content">
    <!-- banner图 -->
    <div class="home_bannerdiv">
      <img :src="bannerList.img" alt="" />
<!--      <div class="banner_title" ref="bannerTitleRef">-->
<!--        &lt;!&ndash; <i style="font-size: 50px">{{ bannerList.title }}</i>-->
<!--        <i style="font-size: 30px; margin-top: 6px">{{ bannerList.content }}</i> &ndash;&gt;-->
<!--        <el-tooltip v-if="hasEllipsis1" :content="bannerList.title" placement="top">-->
<!--          <p  class="title-large" style="font-size: 50px">{{ bannerList.title }}</p>-->
<!--        </el-tooltip>-->
<!--        <p class="title-large" v-else style="font-size: 50px">{{ bannerList.title }}</p>-->
<!--        <el-tooltip  class="title-small" v-if="hasEllipsis2" :content="bannerList.content" placement="top">-->
<!--          <p style="font-size: 30px">{{ bannerList.content }}</p>-->
<!--        </el-tooltip>-->
<!--        <p  class="title-small" v-else style="font-size: 30px">{{ bannerList.content }}</p>-->
<!--      </div>-->
    </div>
    <!-- 主体div -->
    <div class="home_maindiv">
      <!-- 主体左边 -->
      <div class="home_mainleftdiv">
        <div class="home_totaldatadiv">
          <div class="databox" @click="tochangetabs(1)">
            Missing CF/UA
            <span style="color: #ff6b6b">{{ datasetList.missing_count }}</span>
          </div>
          <div class="databox" @click="tochangetabs(2)">
            Upcoming Classes
            <span style="color: #00bfa6">{{ datasetList.upcoming_count }}</span>
          </div>
          <div class="databox" @click="tochangetabs(3)">
            Past Classes
            <span style="color: #3b82f6">{{ datasetList.past_count }}</span>
          </div>
        </div>
        <!-- Upcoming Classes部分 -->
        <div class="upcoming_boxs">
          <p class="upcoming_pbox">
            <span style="margin-left: 20px">Upcoming Classes</span>
            <el-button
              type="primary"
              style="margin-right: 20px"
              @click="toopenslots"
              >Open new slot</el-button
            >
          </p>
          <!-- 列表部分 -->
          <div v-if="scheduleData.length>0">
            <div class="courseList" v-for="(item, i) in scheduleData" :key="i">
              <p class="font_24_bold color_black datestyle">
                {{ item.date }}
              </p>
              <div
                class="classList"
                v-for="(lessonItem, j) in item.data"
                :key="j"
              >
                <div class="titleName flex_start" style="margin-bottom: 17px">
                  <img :src="lessonItem.subject_img" />
                  <div class="flex_1 flex_column_start">
                    <div class="flex_between">
                      <h3 class="font_24_24_reg start_endtime">
                        {{ lessonItem.start_at_time }} -{{
                          lessonItem.end_at_time
                        }}
                      </h3>
                      <button
                        :class="
                          lessonItem.mins
                            ? 'willStartIn'
                            : lessonItem.status == 1 && !lessonItem.mins
                            ? 'pending'
                            : lessonItem.status == 2
                            ? 'completed'
                            : 'btnNone'
                        "
                      >
                        {{
                          lessonItem.mins
                            ? "Starts in " + lessonItem.mins
                            : lessonItem.status == 1 && !lessonItem.mins
                            ? "On Air"
                            : lessonItem.status == 2
                            ? "Completed"
                            : ""
                        }}
                      </button>
                    </div>
                    <div class="card_tr">
                      <span class="card_subtitle">{{
                        lessonItem.subtitle
                      }}</span>
                      <span class="card_lessons"
                        >{{ lessonItem.start_lessons }}/{{
                          lessonItem.total_lessons
                        }}</span
                      >
                      <button class="card_leveltitle">
                        {{ lessonItem.leveltitle }}
                      </button>
                      <p class="color_ora card_student">
                        {{ lessonItem.is_trial ? "Trial student" : "" }}
                      </p>
                      <button
                        v-if="lessonItem.status == 0"
                        class="card_levelbtn"
                        @click="handleCancel(lessonItem)"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
                <div class="flex_center topic" v-if="lessonItem.lesson_topic">
                  <p class="classTopic font_18_reg weight600">Topic:</p>
                  <p class="font_16">{{ lessonItem.lesson_topic }}</p>
                </div>

                <div class="classTimeInfo">
                  <div class="studentList" v-if="lessonItem.student.length > 0">
                    <p
                      :title="studentItem.nickname"
                      v-for="(studentItem, k) in lessonItem.student"
                      :key="k"
                      :class="studentItem.is_trial == 1 ? 'trial' : ''"
                    >
                      {{
                        studentItem.nickname +
                        (studentItem.is_trial == 1 ? "*" : "")
                      }}
                    </p>
                  </div>
                  <div class="actBtn flex_center">
<!--                    //0 未开始     1 进行中    2已结束-->
                    <button
                      type="text"
                      @click="enterClassRoom(lessonItem.lesson_sn)"
                      :disabled="
                        lessonItem.status == 2 ||
                        (lessonItem.status == 0 && !lessonItem.enterStatus)
                      "
                      :class="
                        lessonItem.status == 2 ||
                        (lessonItem.status == 0 && !lessonItem.enterStatus)
                          ? 'disabled enterBtn'
                          : 'enterClass enterBtn'
                      "
                    >
                      Enter Classroom
                    </button>
                    <button
                      type="text"
                      v-if="lessonItem.comment_status == 1"
                      @click="open(lessonItem, 1)"
                      :disabled="lessonItem.status == 0"
                      :class="lessonItem.status == 0 ? 'disabled' : 'leaveBtn'"
                    >
                      Edit Your Note
                    </button>
                    <button
                      type="text"
                      v-else
                      @click="open(lessonItem, 0)"
                      :disabled="lessonItem.status == 0"
                      :class="lessonItem.status == 0 ? 'disabled' : 'leaveBtn'"
                    >
                      Leave a Note
                    </button>
                    <button
                      type="text"
                      @click="toCourseware(lessonItem.courseware_url)"
                      :disabled="!lessonItem.courseware_url"
                      :class="
                        !lessonItem.courseware_url ? 'disabled' : 'leaveBtn'
                      "
                    >
                      View Lesson Material
                    </button>
                    <button
                      type="text"
                      @click="openPre(lessonItem)"
                      v-if="lessonItem.pre_class_notes"
                      class="leaveBtn"
                    >
                      Pre-class Notes
                    </button>
                  </div>
                </div>
                <p
                  class="mt"
                  v-if="!(lessonItem.status == 1 && !lessonItem.mins)"
                >
                  Enter the classroom 15 minutes before class starts
                </p>
              </div>
            </div>
          </div>
          <div v-else class="list_box">
            <div class="listimg_box">
              <img src="@/assets/emptyindex.png" alt="">
            </div>
            <div style="text-align:center;margin-top:20px">There are no upcoming lessons.</div>
            <div style="text-align:center;margin-top:20px">Open more slots to get a higher booking possibility.</div>
          </div>
        </div>
      </div>
      <!-- 主体右边 -->
      <div class="home_mainrightdiv">
        <!-- 个人信息框 -->
        <div class="userInfo">
          <div class="userInfobox1">
            <div class="userinfoimg">
              <img
                :src="userData.avatar"
                alt=""
              />
            </div>
            <div style="margin-left: 20px">
              <h3 style="color: #000; font-size: 20px">Hi,{{userData.alias}}!</h3>
              <p style="margin-top: 15px">
                ID:{{userData.id}}  <span style="margin-left:10px">Current Time Zone:  (UTC{{utils.globetime()}})</span>
              </p>
            </div>
          </div>
          <div class="userInfobox2">
            <!-- 评分 -->
            <p>
              <el-rate
                style="margin-left: 20px; width: 32%"
                v-model="userData.rating_total"
                disabled
                text-color="#FACC15"
                score-template="{value}"
              >
              </el-rate>
              <span>{{userData.rating_total}}</span><span>{{userData.rating_num}}</span><span>Parents' Feedback</span>
            </p>
            <div class="userInfoboxsmall">
              <span>Allow bookings within 24 hours</span>
              <el-switch
                :value="userData.day_course_switch == 1"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="handleSwitchChange"
              >
              </el-switch>
            </div>
            <p style="margin-left: 20px">Invitation code: {{userData.invite_code}} <i @click="copy(userData.invite_code)" style="cursor: pointer;margin-left:10px"
            class="el-icon-document-copy"></i></p>
          </div>
        </div>
        <!-- 日历部分 -->
        <div class="dateInfo" style="padding-bottom: 10px">
          <!-- 自定义导航按钮 -->
          <div class="calendar-header">
            <span class="calendar-month" @click="resetToToday">{{
              currentMonth
            }}</span>
            <div>
              <el-button
                type="text"
                @click="changeMonth(-1)"
                class="calendar-btn"
              >
                <el-icon class="el-icon-arrow-left"></el-icon>
              </el-button>
              <el-button
                type="text"
                @click="changeMonth(1)"
                class="calendar-btn"
              >
                <el-icon class="el-icon-arrow-right"></el-icon>
              </el-button>
            </div>
          </div>

          <!-- 日历主体 -->
          <el-calendar v-model="currentDate">
            <template slot="dateCell" slot-scope="{ date }">
              <div class="el-calendar-day custom-date-cell" :class="{ 'disabled-date': isDisabled(date) }" @click="handleDateClick(date)">
                {{ date.getDate() }}
              </div>
            </template>
          </el-calendar>
        </div>
        <!-- Announcements部分 -->
        <div class="announcementsInfo">
          <h3 style="margin-left: 20px">
            Announcements
            <!-- <span
              style="
                float: right;
                color: #00bfa6;
                font-size: 16px;
                margin-right: 20px;
              "
              >See More</span
            > -->
          </h3>
          <div
            class="annountcebox"
            v-for="(item, index) in noticeList"
            :key="index"
            :class="{ 'no-border': index == noticeList.length - 1 }"
          >
            <p style="margin: 10px 0 0 20px; color: #ccc">
              {{ item.created_at }}
            </p>
            <p style="margin: 10px 0 15px 20px; font-size: 19px">
              <span v-html="item.content"></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Confirm cancel this class" :visible.sync="canceldialogVisible" width="35%"
      :before-close="cancelhandleClose" custom-class="cancelDialog">
      <span v-if="showTimetip2">Are you sure to cancel?</span>
      <span v-if="showTimetip1">Cancelling this lesson (<24 hours notice) will affect your payment for this
          session</span>
          <p style="margin-top: 10px" v-if="showTimetip1">
            Proceed with cancellation ?
          </p>
          <span slot="footer" class="dialog-footer">
            <el-button class="cancelbtn1" v-if="showTimetip2" @click="tohandleCanceldialog">Confirm</el-button>
            <el-button class="Confirmbtn1" v-if="showTimetip2" @click="canceldialogVisible = false">Cancel</el-button>
            <el-button class="cancelbtn1" v-if="showTimetip1" @click="tohandleCanceldialog">Yes,Cancel
              Lesson</el-button>
            <el-button class="Confirmbtn1" v-if="showTimetip1" @click="canceldialogVisible = false">No,Keep
              Lesson</el-button>
          </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      datasetList: {},
      scheduleData: [],
      ratevalue: "3.7",
      switchvalue: true,
      announceList: [
        {
          time: "09:27 PM Jul 03 Thu",
          label: "Import Classroom Updates",
        },
        {
          time: "02:59 PM Jul 03 Thu",
          label: "Inter Classroom Updates",
        },
        {
          time: "01:27 PM Jul 03 Thu",
          label: "314 Classroom Updates",
        },
        {
          time: "05:27 PM Jul 03 Thu",
          label: "43124 Classroom Updates",
        },
        {
          time: "07:27 PM Jul 03 Thu",
          label: "6456 Classroom Updates",
        },
        {
          time: "0-:27 PM Jul 03 Thu",
          label: "fsdf Classroom Updates",
        },
        {
          time: "08:27 PM Jul 03 Thu",
          label: "fgjfyu Classroom Updates",
        },
      ],
      currentDate: new Date(),
      calendarData: [
        { date: "2025-07-21", type: 1 },
        { date: "2025-07-25", type: 2 },
      ],
      bannerList: {},
      noticeList: [],
      interval: null,
      lessonDates: [], // 用于存储提取的课程日期
      userData:{},
      showTimetip1: false,
      showTimetip2: false,
      cancellesson: "",
      canceldialogVisible: false, //取消弹框
      hasEllipsis1: false,
      hasEllipsis2: false
    };
  },
  computed: {
    // 格式化当前年月显示文字
    currentMonth() {
      return this.currentDate.toLocaleString('en-US', {
        year: 'numeric',    // 数字形式的年份（如2025）
        month: 'long'       // 完整的月份名称（如July）
      });
    },
  },
  watch: {
    // 月份变化时重新渲染高亮
    currentDate() {
      this.$nextTick(() => {
        this.processCalendarData();
      });
    },
  },
  mounted() {
    this.processCalendarData();
    this.getBanner();
    this.getTotalList();
    this.getTeacherLesson();
    this.search();
        this.$http
      .get("/tutor/api/getGlobalInfo?time=" + this.utils.timeZone())
      .then((res) => {
        if (res.data.code == 200) {
          this.userData = res.data.data;
          this.value5 = this.userData.rating_total;
          this.pl = this.userData.rating_num;
          this.remind = res.data.data.is_sms == "1";
          sessionStorage.setItem('avatar',res.data.data.avatar)
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error); // 请求失败返回的数据
      });
    this.checkEllipsis();
    window.addEventListener("resize", this.checkEllipsis);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkEllipsis);
  },
  methods: {
    tochangetabs(type){
      let newActivevalue
      if(type==1){
        newActivevalue='lesson'
      }else if(type==2){
        newActivevalue='schedule'
      }else if(type==3){
        newActivevalue='lesson'
      }
      this.$emit("editActive", newActivevalue);
    },
    // 判断日期是否需要禁用
    isDisabled(date) {
      // 这里可以根据实际需求编写判断逻辑
      // 示例：禁用所有过去的日期
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;

      // 示例2：禁用特定日期（2023年10月15日）
      // const disabledDate = new Date(2023, 9, 15); // 月份从0开始
      // return date.getFullYear() === disabledDate.getFullYear() &&
      //        date.getMonth() === disabledDate.getMonth() &&
      //        date.getDate() === disabledDate.getDate();
    },

    // 处理日期点击事件
    handleDateClick(date) {
      if (this.isDisabled(date)) {
        // 如果是禁用日期，阻止默认行为
        event.stopPropagation();
        return false;
      }
      // 正常日期的点击处理逻辑
      this.currentDate = date;
    },
    copy(text) {
      navigator.permissions.query({ name: 'clipboard-write' }).then(result => {
        if (result.state === 'granted' || result.state === 'prompt') {
          // 可以写入剪贴板
          try {
            navigator.clipboard.writeText(text);
            this.$message({
              type: 'success',
              message: 'Copy successful!',
            })
          } catch (err) {
            this.$message({
              type: 'error',
              message: 'The content cannot be copied: ' + err,
            })
          }
        }
      });
    },
    checkEllipsis() {
      const bannerTitleDom = this.$refs.bannerTitleRef;
      if (!bannerTitleDom) return;
      const titleLargeDom = bannerTitleDom.querySelector(".title-large");
      const titleSmallDom = bannerTitleDom.querySelector(".title-small");
      this.hasEllipsis1 = this.isTextOverflow(titleLargeDom);
      this.hasEllipsis2 = this.isTextOverflow(titleSmallDom);
    },
    isTextOverflow(dom) {
      if (!dom) return false;
      const domStyles = window.getComputedStyle(dom);
      const helperDom = document.createElement("span");
      helperDom.className = "helper-element";
      helperDom.style.visibility = "hidden";
      helperDom.style.position = "absolute";
      helperDom.style.whiteSpace = "nowrap";
      helperDom.style.padding = "0";
      helperDom.style.margin = "0";
      helperDom.style.border = "none";
      helperDom.style.fontSize = domStyles.fontSize;
      helperDom.style.fontFamily = domStyles.fontFamily;
      helperDom.style.fontStyle = domStyles.fontStyle;
      helperDom.style.fontWeight = domStyles.fontWeight;
      helperDom.style.letterSpacing = domStyles.letterSpacing;
      helperDom.style.textTransform = domStyles.textTransform;
      helperDom.style.wordSpacing = domStyles.wordSpacing;
      helperDom.textContent = dom.textContent;
      document.body.appendChild(helperDom);
      const isOverflow = helperDom.scrollWidth > dom.clientWidth;
      document.body.removeChild(helperDom);
      return isOverflow;
    },
    tohandleCanceldialog() {
      this.$http
        .post("/tutor/api/cancelClass", {
          lesson_sn: this.cancellesson,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.search();
            this.getTotalList();
          }
        });
      this.canceldialogVisible = false;
    },
    cancelhandleClose() {
      this.canceldialogVisible = false;
      this.getTotalList();
    },
    toCourseware(url) {
      window.open(url, "_blank");
    },
    alertMsg() {
      this.$alert(
        '<p style="font-size:30px;text-align: center;margin: 55px 0;">Thank you! Note Received.</p>',
        "",
        {
          confirmButtonText: "Back to Main Page",
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            this.search();
          },
        }
      );
    },
    openPre(lessonItem){
      this.$http.post("/tutor/api/readClassNotes", {
          lesson_sn: lessonItem.lesson_sn,
        })
        .then(res => {
          this.$confirm(lessonItem.pre_class_notes, 'Pre-class Notes', {
            confirmButtonText: 'OK',
            customClass: "Pre-class",
            showCancelButton:false
          }).then(() => {
          }).catch(action => {
          });
        })
    },
    open(lessonItem, type) {
      this.$prompt(
        "Your note will help us evaluate the students learning progress and provide them the best learning experience.<p>Note:</p>",
        "Note for the lesson",
        {
          confirmButtonText: "Submit Comment",
          customClass: "noteClass",
          // confirmButtonClass:'submitNote',
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          inputType: "textarea",
          inputPlaceholder: "Type your note here: ",
          inputValue: lessonItem.comnents,
        }
      )
        .then(({ value }) => {
          if (value != "") {
            if (type == 0) {
              this.$http
                .post("/tutor/api/addTeacherComment", {
                  comment: value,
                  teacher_sn: lessonItem.teacher_sn,
                  lesson_sn: lessonItem.lesson_sn,
                  class_sn: lessonItem.class_sn,
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      message: res.data.data,
                      type: "success",
                    });
                    this.alertMsg();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "warning",
                    });
                  }
                })
                .catch((error) => {
                  console.log(error); // 请求失败返回的数据
                });
            } else {
              this.$http
                .post("/tutor/api/addTeacherComment", {
                  comment: value,
                  teacher_sn: lessonItem.teacher_sn,
                  lesson_sn: lessonItem.lesson_sn,
                  class_sn: lessonItem.class_sn,
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$message({
                      message: res.data.data,
                      type: "success",
                    });
                    this.alertMsg();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "warning",
                    });
                  }
                })
                .catch((error) => {
                  console.log(error); // 请求失败返回的数据
                });
            }
          }
        })
        .catch((error) => {
          this.$message({
            type: "info",
            message: error,
          });
        });
    },
    enterClassRoom(lesson_sn) {
      this.$http
        .get("/tutor/api/lesson/teacherEntry/" + lesson_sn)
        .then((res) => {
          if (res.data.code == 200) {
            window.open(res.data.url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    // 删除课程弹框
    handleCancel(lessonItem) {
      const startTime = new Date(lessonItem.start_at).getTime();
      const currentTime = new Date().getTime();
      const timeDiff = startTime - currentTime;
      if (timeDiff > 0 && timeDiff < 86400000) {
        // 小于24小时
        this.showTimetip1 = true;
        this.showTimetip2 = false;
      } else {
        // 大于等于24小时
        this.showTimetip1 = false;
        this.showTimetip2 = true;
      }
      this.cancellesson = lessonItem.lesson_sn;
      this.canceldialogVisible = true;
    },
    // 处理开关切换事件
    handleSwitchChange(newValue) {
      const status = newValue ? 1 : 0;
      this.userData.day_course_switch = status;
      this.updateSwitchStatus(status)
        .then(() => {
          this.userData.day_course_switch = status;
          console.log('状态更新成功');
        })
        .catch(error => {
          console.error('状态更新失败：', error);
          this.$set(this.userData, 'day_course_switch', this.userData.day_course_switch);
        });
    },
    updateSwitchStatus(status) {
      return this.$http.post('/tutor/api/bookingSwitch', {
        day_course_switch: status
      });
    },
    toopenslots() {
      const newActivevalue = "time";
      this.$emit("editActive", newActivevalue);
    },
    // 格式化日期为 YYYY-MM-DD 格式
    formatDate(date) {
      const year = date.getFullYear();
      // 月份和日期需要补零
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    search() {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      const startDate = this.formatDate(today);
      const endDate = this.formatDate(tomorrow);
      const url = `/tutor/api/indexMySchedule?start_date=${startDate}&pagesize=10&page=1&end_date=${endDate}&time=${this.utils.timeZone()}`;
      // 我的时间表
      this.$http
        .get(url)
        .then((res) => {
          if (res.data.code == 200) {
            this.scheduleData = res.data.data.datas;
            this.total = res.data.total;
            if (this.interval) {
              // 判断定时器这个属性是否为空,存在则清除
              clearInterval(this.interval);
            }
            this.interval = setInterval(() => {
              // 这个interval是在data(){return{}} 中创建，初始化为null 防止重复请求到这个页面定时器重复生成
              this.timeStatus();
              this.$forceUpdate();
            }, 1000);
            // })
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    timeStatus() {
      for (var i in this.scheduleData) {
        var item = this.scheduleData[i].data;
        item.map((timeItem, k) => {
          var hoursRound = "";
          var minutesRound = "";
          let beg = this.utils.formatDate(timeItem.start_at_utc).getTime(); // 开始秒数
          let now = this.utils.formatDate(timeItem.now_time_utc).getTime(); // 时区秒数

          let begTime = beg - now;

          let begTime2 = (timeItem.start_at_timestamp - timeItem.now_time_timestamp) * 1000

          if (begTime2 >= 0 && begTime2 < 172800000) {
            hoursRound = Math.floor(begTime2 / 1000 / 60 / 60);
            minutesRound = Math.floor((begTime2 / 1000 / 60) % 60);
            if (hoursRound == 0 && minutesRound == 0) {
              timeItem.mins = null;
            } else {
              timeItem.mins = hoursRound + " hours " + minutesRound + " mins";
            }
          }else if (begTime2 < 0) {
            timeItem.mins = null;
          }
          if (begTime < 900000) {
            timeItem.enterStatus = true;
          }
        });
      }
      return this.scheduleData;
    },
    // 获取banner图
    getBanner() {
      this.$http
        .get("/tutor/api/homeBanner?pagesize=10&page=1")
        .then((res) => {
          if (res.status == 200) {
            this.bannerList = res.data.data.data.banner;
            this.noticeList = res.data.data.data.notice;
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    // 获取统计数据
    getTotalList() {
      this.$http
        .get("/tutor/api/indexCount")
        .then((res) => {
          if (res.status == 200) {
            this.datasetList = res.data.data;
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    // 获取老师所有课的日期
    getTeacherLesson() {
      this.$http
        .get("/tutor/api/allCourseDate?time=8")
        .then((res) => {
          console.log("aaaaaaaaaa", res);
          if (res.status == 200) {
            this.lessonDates = res.data.data.lesson_data.map((item) => {
              // 从"2025-08-22 19:00:00"中提取"2025-08-22"
              return item.start_at.split(" ")[0];
            });
            // 数据更新后重新处理日历高亮
            this.$nextTick(() => {
              this.processCalendarData();
            });
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    processCalendarData() {
      // 1. 清除所有已有的高亮类名
      document.querySelectorAll(".el-calendar-day").forEach((el) => {
        el.classList.remove("orange-highlight", "red-highlight");
      });

      // 2. 处理每个日历日期，与课程日期匹配
      const currentDisplayYear = this.currentDate.getFullYear();
      const currentDisplayMonth = this.currentDate.getMonth() + 1; // 月份+1，因为JS月份从0开始

      document.querySelectorAll(".el-calendar-day").forEach((cell) => {
        const dayNumber = parseInt(cell.textContent.trim());
        // 跳过无效日期（如上个月/下个月的灰色日期）
        if (isNaN(dayNumber)) return;

        // 构建当前单元格的完整日期（格式：YYYY-MM-DD）
        const cellDate = `${currentDisplayYear}-${currentDisplayMonth
          .toString()
          .padStart(2, "0")}-${dayNumber.toString().padStart(2, "0")}`;

        // 检查是否在课程日期列表中，是则添加红色高亮
        if (this.lessonDates.includes(cellDate)) {
          cell.classList.add("red-highlight");
        }
      });
    },
    // 月份切换后重新处理高亮
    changeMonth(step) {
      const newDate = new Date(this.currentDate);
      newDate.setMonth(newDate.getMonth() + step);
      this.currentDate = newDate;
      // 等待DOM更新后再处理高亮
      this.$nextTick(() => {
        this.processCalendarData();
      });
    },

    // 重置到今天后重新处理高亮
    resetToToday() {
      this.currentDate = new Date();
      this.$nextTick(() => {
        this.processCalendarData();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index_content {
  background: #fff8d0;
  margin-top: 20px;
  .home_bannerdiv {
    width: 100%;
    height: 250px;
    border-radius: 10px;
    background: #fff;
    position: relative;
    img{
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
    .banner_title {
      position: absolute;
      top: 30%;
      left: 10%;
      font-style: italic;
      width: 80%;
      p {
        white-space: nowrap; /* 强制不换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        margin: 0 0 10px 0; /* 移除默认边距，添加垂直间距 */
      }
    }
    .title-large {
      font-size: 50px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 0 10px 0;
    }
    .title-small {
      font-size: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
    }
    .helper-element {
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-style: italic;
      font-size: inherit;
      padding: 0;
      margin: 0;
    }
  }
  .banner_title:hover{
    cursor: pointer;
  }
  .banner_title p:first-child {
  font-weight: bold;
}
  .home_maindiv {
    width: 100%;
    margin-top: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .home_mainleftdiv {
      width: 68%;
      height: 100%;
      border-radius: 10px;
      .home_totaldatadiv {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: space-between;
        background: #fff8d0;
        font-size: 18px;
        .databox {
          width: 27%;
          height: 100%;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          background: #fff;
        }
        .databox:hover{
          cursor: pointer;
        }
      }
      .upcoming_boxs {
        background: #fff;
        width: 100%;
        height: 82%;
        margin-top: 20px;
        border-radius: 10px;
        .upcoming_pbox {
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .courseList {
          //margin:0 15px;
          > p.font_24_bold {
            margin: 15px 0;
          }

          .classList {
            margin: 24px 0;
            background: #f9fafb;
            border-radius: 10px;
            padding: 24px 28px;

            .flex_1 {
              flex: 1;
              //height:103px;
            }

            .mt {
              margin: 10px 0 0 0;
              font-family: Arial;
              font-size: 14px;
              font-weight: normal;
              line-height: 20px;
              letter-spacing: 0px;

              color: #666666;
            }

            .titleName {
              width: 100%;

              > img {
                width: 64px;
                height: 64px;
                margin-right: 10px;
                background: #ffffff;
                border-radius: 10px;
                margin-right: 15px;
              }

              > span {
                width: 6px;
                height: 6px;
                border-radius: 2px;
                background: #a5a5a5;
                margin: 0 20px;
              }

              > button {
                height: 36px;
                line-height: 36px;
                padding: 0 10px;
                border: none;
                font-size: 16px;
                background: #e7e7e7;
                border-radius: 7px;
                color: #1d2d3a;
              }

              .color_ora {
                color: #f26942;
                font-size: 14px;
                margin: 0 25px;
              }

              .topic {
                .classTopic {
                  margin-right: 16px;
                }
              }
            }

            .classTimeInfo {
              // margin-left:15px;
              // margin-top:10px;
              .studentList {
                // background: #ffffff;
                // border-radius: 8px;
                margin: 10px 0 20px 0;
                // padding:7px 0;
                flex: 1;
                line-height: 24px;
                width: 500px;
                display: flex;
                flex-wrap: wrap;

                p {
                  width: 230px;
                  margin-right: 20px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-break: break-all;
                  display: inline-block;
                  color: #353643;
                  font-size: 16px;

                  &.trial {
                    color: #eb4701;
                  }
                }
              }

              .actBtn {
                width: 100%;
                justify-content: flex-start;
                button {
                  // width:200px;
                  height: 50px;
                  margin-right: 24px;
                  padding: 0 16px;
                  border-radius: 8px;
                }

                .enterBtn {
                  width: 277px;
                }

                img {
                  box-shadow: 0px 1px 6px 1px rgba(81, 124, 255, 0.2);
                  border-radius: 50%;
                  cursor: pointer;
                }

                p {
                  color: #ff6440;
                  cursor: pointer;
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
    }
    .home_mainrightdiv {
      width: 30%;
      height: 100%;
      background: #fff8d0;
      border-radius: 10px;
      .userInfo {
        width: 100%;
        height: 220px;
        border-radius: 10px;
        background: #fff;
        color: #a5a5a5;
        font-size: 14px;
        .userInfobox1 {
          width: 100%;
          height: 55%;
          display: flex;
          align-items: center;
          .userinfoimg {
            width: 120px;
            height: 115px;
            border-radius: 50%;
            img {
              width: 80%;
              height: 80%;
              border-radius: 50%;
              margin-left: 20px;
              margin-top: 18px;
              border: 1px solid #ccc;
            }
          }
        }
        .userInfobox2 {
          width: 100%;
          height: 45%;
          .userInfoboxsmall {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 10px 20px 10px 20px;
          }
          p {
            display: flex;
            align-items: center;
            span {
              margin-left: 15px;
            }
          }
        }
      }
      .dateInfo {
        width: 100%;
        border-radius: 10px;
        background: #fff;
        margin-top: 20px;
        .calendar-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .calendar-month {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin: 10px 0 10px 25px;
        }

        .calendar-btn {
          color: #666;
          padding: 4px 12px;
        }
      }
      .announcementsInfo {
        width: 100%;
        height: 565px;
        border-radius: 10px;
        margin-top: 20px;
        padding-top: 15px;
        background: #fff;
        overflow: auto;
        .annountcebox {
          width: 100%;
          margin-top: 15px;
          border-bottom: 1px solid #e5e7eb;
        }
        .no-border {
          border-bottom: none !important;
        }
      }
    }
  }
}
/* 基础日期单元格样式 */
.dateInfo /deep/ .el-calendar-day {
  width: 36px;
  height: 36px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50%;
  margin: 0 auto;
}
.dateInfo /deep/.el-calendar-table td.is-selected {
  background-color: #ff904d !important;
  color: #fff !important;
  width: 40px;
  height: 40px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 50%;
  margin: 0 auto;
}

/* 橙色高亮样式 */
.dateInfo /deep/ .orange-highlight {
  background-color: #ff7d00 !important;
  color: white !important;
  font-weight: bold;
}

/* 红色高亮样式 */
.dateInfo /deep/ .red-highlight {
  background-color: #f53f3f !important;
  color: white !important;
  font-weight: bold;
}

/* 隐藏默认头部 */
.dateInfo /deep/ .el-calendar__header {
  display: none !important;
}
.dateInfo /deep/ .el-calendar-table td {
  border: none !important;
}
.card_tr {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
  position: relative;

  .card_subtitle {
    font-family: Arial;
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
    letter-spacing: 0px;

    color: #333333;
  }

  .card_lessons {
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    color: #666666;
    margin-left: 12px;
  }

  .card_leveltitle {
    padding: 4px 8px;
    background: #e5e7eb;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    border-radius: 8px;
    border: none;
    margin-left: 8px;
    color: #333333;
  }

  .card_levelbtn {
    padding: 10px 14px;
    background: #ff904d;
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    border-radius: 8px;
    border: none;
    color: #fff;
    position: absolute;
    right: 10px;
  }

  .card_student {
    font-family: Arial;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    display: inline-block;
    margin-left: 18.6px;
    color: #2563eb;
  }
}
.datestyle {
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;
  padding:0 15px !important;
  color: #333333;
}

.start_endtime {
  font-family: Arial;
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
  letter-spacing: 0px;

  color: #333333;
}
.list_box{
  width: 100%;
  height: 960px;
  .listimg_box{
    width: 200px;
    height: 200px;
    margin: 60px auto 0 auto;
    img{
      width: 100%;
      height: 100%;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue